export default {"src":"/_next/static/media/shampoo.2f137e68.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};